export default __webpack_public_path__ + "media/user-image.bfbf34bb.png";